import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import parse from 'html-react-parser';

// material-ui
import { useTheme } from '@mui/material/styles';
import { CardContent, Grid, Typography } from '@mui/material';

// project imports
import Avatar from 'ui-component/extended/Avatar';
import { gridSpacing } from 'store/constant';

// assets
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import SubCard from 'ui-component/cards/SubCard';

// third party
import PerfectScrollbar from 'react-perfect-scrollbar';

const TasksCard = ({ title, history }) => {

    const theme = useTheme();

    const formatCreatedAt = (createdAt) => {
        const timestamp = moment(createdAt);
        const todayStart = moment().startOf('day');
        const yesterdayStart = moment(todayStart).subtract(1, 'day');
        if (timestamp.isSame(todayStart, 'day')) {
            return timestamp.format('h:mm:ss A');
        } else if (timestamp.isBetween(yesterdayStart, todayStart, null, '[)')) {
            return `Yesterday, ${timestamp.format('h:mm A')}`;
        } else {
            return timestamp.format('ddd, DD MMM');
        }
    };

    const getIcon = (color) => {
        switch (color) {
            case 'success':
                return <CheckCircleOutlineOutlinedIcon />;
            case 'error':
                return <CancelOutlinedIcon />;
            case 'primary':
                return <InfoOutlinedIcon />
            case 'warning':
                return <ErrorOutlineOutlinedIcon />
            case 'info':
                return < InfoOutlinedIcon />
            default:
                return <InfoOutlinedIcon />;
        };
    };

    return (
        <SubCard title={title} content={false}>
            <PerfectScrollbar style={{ height: 580 }}>
                <CardContent>
                    <Grid
                        container
                        spacing={gridSpacing}
                        alignItems="center"
                        sx={{
                            position: 'relative',
                            '&>*': {
                                position: 'relative',
                                zIndex: 5
                            },
                            '&:after': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                left: 43,
                                width: 2,
                                height: '100%',
                                background: '#ebebeb',
                                zIndex: 1
                            }
                        }}
                    >
                        {history.reverse().map((item, index) => (
                            <Grid item xs={12} key={index}>
                                <Grid container spacing={2}>
                                    <Grid item>
                                        <Avatar size="sm" sx={{
                                            top: 10,
                                            color: "#fff",
                                            bgcolor: theme.palette[item.color].main,
                                            width: 38,
                                            height: 38,
                                        }}>
                                            {history ? getIcon(item.color) : ''}
                                        </Avatar>
                                    </Grid>
                                    <Grid item xs zeroMinWidth>
                                        <Grid container spacing={0}>
                                            <Grid item xs={12}>
                                                <Typography align="left" variant="caption">
                                                    {formatCreatedAt(item.created_at)}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Typography align="left" variant="body2">
                                                    {parse(item.message)}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </CardContent>
            </PerfectScrollbar>
        </SubCard>
    )
}

TasksCard.propTypes = {
    title: PropTypes.string
};

export default TasksCard;
